import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import SurahReader from './pages/SurahReader';
import Bookmarks from './pages/Bookmarks';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AudioPlayer from './components/AudioPlayer';
import { AudioProvider } from './context/AudioContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from 'sonner';
import { firebaseService } from './services/FirebaseService';
import { mobileAdService } from './services/MobileAdService';
import '@/App.css';

function App() {
  useEffect(() => {
    // Initialize Firebase and AdMob services
    const initServices = async () => {
      await firebaseService.initialize();
      await mobileAdService.initialize();
      // Show banner ad at bottom on mobile
      await mobileAdService.showBannerAd('BOTTOM');
    };
    initServices();
  }, []);

  return (
    <LanguageProvider>
      <AudioProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/surah/:chapterId" element={<SurahReader />} />
              <Route path="/bookmarks" element={<Bookmarks />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
            <AudioPlayer />
          </BrowserRouter>
          <Toaster position="top-center" />
        </div>
      </AudioProvider>
    </LanguageProvider>
  );
}

export default App;